var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 53.25C3.2595 53.25 2.25 52.2405 2.25 51C2.25 50.58 2.385 50.1555 2.6595 49.7025L27.942 8.0775C28.2435 7.581 28.911 6.75 30 6.75C31.089 6.75 31.7565 7.581 32.0565 8.0775L57.3375 49.7025C57.615 50.1555 57.75 50.58 57.75 51C57.75 52.2405 56.7405 53.25 55.5 53.25H4.5Z",
    fill: "#F7A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 7.5C30.7215 7.5 31.197 8.1045 31.416 8.466L44.0565 29.2785L56.697 50.091C56.901 50.4255 57 50.7225 57 51C57 51.8265 56.3265 52.5 55.5 52.5H4.5C3.6735 52.5 3 51.8265 3 51C3 50.7225 3.099 50.4255 3.3015 50.091L15.942 29.2785L28.5825 8.466C28.803 8.106 29.2785 7.5 30 7.5ZM30 6C28.8135 6 27.879 6.738 27.3015 7.6875C2.019 49.3125 27.3015 7.6875 2.019 49.3125C1.7175 49.809 1.5 50.3745 1.5 51C1.5 52.6575 2.8425 54 4.5 54C5.811 54 54.09 54 55.5 54C57.1575 54 58.5 52.6575 58.5 51C58.5 50.3745 58.2825 49.809 57.981 49.3125C32.6985 7.6875 57.981 49.3125 32.6985 7.6875C32.121 6.738 31.1865 6 30 6Z",
    fill: "#C74343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.815 26.1645L11.223 25.491L3.04348 24.51L2.18848 25.9185L10.368 26.8995L10.815 26.1645Z",
    fill: "#36404D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7351 13.122L13.7611 6.86548L12.9316 8.23198L17.9056 14.49L18.7351 13.122Z",
    fill: "#36404D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2036 20.5829L14.9836 19.2989L8.42258 15.6539L7.64258 16.9379L14.2036 20.5829Z",
    fill: "#36404D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1851 26.1645L48.7771 25.491L56.9566 24.51L57.8116 25.9185L49.6321 26.8995L49.1851 26.1645Z",
    fill: "#36404D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2649 13.122L46.2389 6.86548L47.0684 8.23198L42.0944 14.49L41.2649 13.122Z",
    fill: "#36404D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7966 20.5829L45.0166 19.2989L51.5776 15.6539L52.3576 16.9379L45.7966 20.5829Z",
    fill: "#36404D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30 48C31.6569 48 33 46.6569 33 45C33 43.3431 31.6569 42 30 42C28.3431 42 27 43.3431 27 45C27 46.6569 28.3431 48 30 48Z",
    fill: "#36404D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21C28.3425 21 27 22.239 27 23.769C27 24.792 28.503 37.7265 28.5105 37.7805C28.599 38.4675 29.232 39 30 39C30.768 39 31.401 38.4675 31.4895 37.7805C31.497 37.7265 33 24.792 33 23.769C33 22.239 31.6575 21 30 21Z",
    fill: "#36404D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.bd56a6276796fd561673784cf8a58c1e.svg";
export { ForwardRef as ReactComponent };